<template>
   <div>
    <div id="console"></div>
    <div id="container"></div>
  </div>
</template>

<script>
import {
  AbsoluteOrientationSensor
  // RelativeOrientationSensor
} from 'motion-sensors-polyfill'
import * as THREE from 'three'
// import { OrbitControls } from './jsm/controls/OrbitControls.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
var camera, scene, renderer, container, sensor
var pointLight, pointLight2

const params = new URLSearchParams(new URL(window.location.href).search.slice(1))
// const relative = !!Number(params.get("relative"));
const coordinateSystem = params.get('coord')

export default {
  name: 'Disco',
  data: function () {
    return {
    }
  },
  mounted: function () {
    if (navigator.permissions) {
      // https://w3c.github.io/orientation-sensor/#model
      Promise.all([navigator.permissions.query({ name: 'accelerometer' }),
        navigator.permissions.query({ name: 'magnetometer' }),
        navigator.permissions.query({ name: 'gyroscope' })])
        .then(results => {
          if (results.every(result => result.state === 'granted')) {
            this.initSensor()
          } else {
            console.log('Permission to use sensor was denied.')
          }
        }).catch(err => {
          console.log('Integration with Permissions API is not enabled, still try to start app.' + err)
          this.initSensor()
        })
    } else {
      console.log('No Permissions API, still try to start app.')
      this.initSensor()
    }
    this.init()
    this.animate()
  },
  methods: {
    initSensor () {
      const options = { frequency: 60, coordinateSystem }
      console.log(JSON.stringify(options))
      sensor = new AbsoluteOrientationSensor(options)
      sensor.onreading = () => (pointLight.quaternion.fromArray(sensor.quaternion).inverse)()
      sensor.onerror = (event) => {
        if (event.error.name === 'NotReadableError') {
          console.log('Sensor is not available.')
        }
      }
      sensor.start()
      console.log(sensor)
    },
    createLight (color) {
      var intensity = 1.5

      var pointLight = new THREE.PointLight(color, intensity, 20)
      pointLight.castShadow = true
      pointLight.shadow.camera.near = 1
      pointLight.shadow.camera.far = 60
      pointLight.shadow.bias = -0.005 // reduces self-shadowing on double-sided objects

      var geometry = new THREE.SphereBufferGeometry(0.3, 12, 6)
      var material = new THREE.MeshBasicMaterial({ color: color })
      material.color.multiplyScalar(intensity)
      var sphere = new THREE.Mesh(geometry, material)
      pointLight.add(sphere)

      var texture = new THREE.CanvasTexture(this.generateTexture())
      texture.magFilter = THREE.NearestFilter
      texture.wrapT = THREE.RepeatWrapping
      texture.wrapS = THREE.RepeatWrapping
      texture.repeat.set(1, 4.5)

      geometry = new THREE.SphereBufferGeometry(2, 32, 8)
      material = new THREE.MeshPhongMaterial({
        side: THREE.DoubleSide,
        alphaMap: texture,
        alphaTest: 0.5
      })

      sphere = new THREE.Mesh(geometry, material)
      sphere.castShadow = true
      sphere.receiveShadow = true
      pointLight.add(sphere)

      // custom distance material
      var distanceMaterial = new THREE.MeshDistanceMaterial({
        alphaMap: material.alphaMap,
        alphaTest: material.alphaTest
      })
      sphere.customDistanceMaterial = distanceMaterial

      return pointLight
    },

    init () {
      container = document.getElementById('container')
      // document.body.appendChild(container);

      camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 100)
      camera.position.set(0, 10, 40)

      scene = new THREE.Scene()
      scene.add(new THREE.AmbientLight(0x111122))
      // lights

      pointLight = this.createLight(0x008fff)
      scene.add(pointLight)

      pointLight2 = this.createLight(0xff8888)
      scene.add(pointLight2)
      //

      var geometry = new THREE.BoxBufferGeometry(30, 30, 30)

      var material = new THREE.MeshPhongMaterial({
        color: 0xa0adaf,
        shininess: 10,
        specular: 0x111111,
        side: THREE.BackSide
      })

      var mesh = new THREE.Mesh(geometry, material)
      mesh.position.y = 10
      mesh.receiveShadow = true
      scene.add(mesh)

      //

      renderer = new THREE.WebGLRenderer({ antialias: true })
      renderer.setPixelRatio(window.devicePixelRatio)
      renderer.setSize(window.innerWidth * 0.8, window.innerHeight * 0.8)
      renderer.shadowMap.enabled = true
      renderer.shadowMap.type = THREE.BasicShadowMap

      container.appendChild(renderer.domElement)
      // document.body.appendChild( renderer.domElement );

      var controls = new OrbitControls(camera, renderer.domElement)
      controls.target.set(0, 10, 0)
      controls.update()

      // stats = new Stats();
      // document.body.appendChild( stats.dom );

      //

      window.addEventListener('resize', this.onWindowResize, false)
    },

    onWindowResize () {
      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()

      renderer.setSize(window.innerWidth * 0.8, window.innerHeight * 0.8)
    },

    generateTexture () {
      var canvas = document.createElement('canvas')
      canvas.width = 2
      canvas.height = 2

      var context = canvas.getContext('2d')
      context.fillStyle = 'white'
      context.fillRect(0, 1, 2, 1)

      return canvas
    },

    animate () {
      requestAnimationFrame(this.animate)
      this.render()
    },
    render () {
      var time = performance.now() * 0.001

      pointLight.position.x = Math.sin(time * 0.6) * 9
      pointLight.position.y = Math.sin(time * 0.7) * 9 + 6
      pointLight.position.z = Math.sin(time * 0.8) * 9

      //   pointLight.rotation.x = time
      //   pointLight.rotation.z = time

      time += 10000

      pointLight2.position.x = Math.sin(time * 0.6) * 9
      pointLight2.position.y = Math.sin(time * 0.7) * 9 + 6
      pointLight2.position.z = Math.sin(time * 0.8) * 9

      pointLight2.rotation.x = time
      pointLight2.rotation.z = time

      renderer.render(scene, camera)

      // stats.update();
    }
  }
}
</script>
